import React from 'react';
import { Flex, View } from '@adobe/react-spectrum';
import PinOn from '@spectrum-icons/workflow/PinOn';
export const LockedPin = () => (React.createElement(Flex, { position: "absolute", top: 0, right: 0, bottom: 0, left: 0, alignItems: "center", justifyContent: "center" },
    React.createElement(View, { backgroundColor: "red-400", width: "size-300", height: "size-300", UNSAFE_style: { opacity: 0.6, borderRadius: '50%' } },
        React.createElement(PinOn, { size: "S", UNSAFE_style: {
                marginLeft: '4px',
                marginTop: '1px',
            } }))));
